import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const TOOLBAR_OPTIONS = [
  [{ header: [2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['blockquote', 'link'],
  ['clean'],
];

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const containerRef = useRef(null);
  const quillRef = useRef(null);
  const onChangeRef = useRef(onChange);

  // Mantém a referência do callback sempre atualizada
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  // Inicializa o Quill uma única vez
  useEffect(() => {
    if (quillRef.current) return;

    const container = containerRef.current;
    if (!container) return;

    const editorDiv = document.createElement('div');
    container.appendChild(editorDiv);

    const quill = new Quill(editorDiv, {
      theme: 'snow',
      placeholder: placeholder || 'Escreva aqui...',
      modules: { toolbar: TOOLBAR_OPTIONS },
    });

    quillRef.current = quill;

    quill.on(Quill.events.TEXT_CHANGE, () => {
      const html = quill.getSemanticHTML();
      onChangeRef.current(html);
    });

    return () => {
      quillRef.current = null;
      container.innerHTML = '';
    };
  }, [placeholder]);

  // Sincroniza o valor externo somente quando o editor não está focado
  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) return;
    if (quill.hasFocus()) return;

    const currentHtml = quill.getSemanticHTML();
    if (value !== currentHtml) {
      const delta = quill.clipboard.convert({ html: value || '' });
      quill.setContents(delta, 'silent');
    }
  }, [value]);

  return (
    <div>
      <div ref={containerRef} className="quill-wrapper" />
      <style>{`
        .quill-wrapper .ql-container {
          min-height: 280px;
          font-size: 16px;
          font-family: inherit;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        .quill-wrapper .ql-toolbar {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background: #f8fafc;
        }
        .quill-wrapper .ql-editor {
          min-height: 280px;
          line-height: 1.8;
        }
        .quill-wrapper .ql-editor p,
        .quill-wrapper .ql-editor h1,
        .quill-wrapper .ql-editor h2,
        .quill-wrapper .ql-editor h3 {
          margin-left: 0;
          padding-left: 0;
          text-indent: 0;
        }
        .quill-wrapper .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: normal;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
